/** Asserts that a value is never, throwing an error if it is not.
 * Useful in switch statements to ensure all cases are handled.
 */
export function assertNever(value: never): never {
  throw new Error(`Unhandled value: ${value}`);
}
